// extracted by mini-css-extract-plugin
export var width100 = "W_w d_w";
export var design3Pos = "W_xV d_0";